import React from 'react';
import PropTypes from 'prop-types';

import JobsUserContainer from './JobsUserContainer';
import FlatHeadlessJobsContainer from './FlatHeadlessJobsContainer';

const FlatHeadlessJobsContainerWrapper = ({ isSubaccountDashboard, ...props }) => (
  <JobsUserContainer {...props}>
    <FlatHeadlessJobsContainer isSubaccountDashboard={isSubaccountDashboard} />
  </JobsUserContainer>
);

FlatHeadlessJobsContainerWrapper.defaultProps = {
  isSubaccountDashboard: false,
};
FlatHeadlessJobsContainerWrapper.propTypes = {
  isSubaccountDashboard: PropTypes.bool,
};

export default FlatHeadlessJobsContainerWrapper;
